import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { CoachAPI } from '../../../api/CoachAPI';
import { useSelector } from 'react-redux';
import Loader from '../../../component/Loader';
import { Autocomplete, Avatar, Button, Chip, Dialog, DialogContent, DialogContentText, DialogTitle, Slide, TextField } from '@mui/material';
import defaultProfileImg from "../../../assets/images/default_profile_img.png";
import { TiUserDeleteOutline } from "react-icons/ti";
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const TeamPlayerList = () => {
    document.title = "Players";
    const { state } = useLocation();
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [isLoading, setIsLoading] = useState(false);
    const [players, setPlayers] = useState([]);
    const [teamPlayers, setTeamPlayers] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);


    const findAllPlayers = async () => {
        try {
            setIsLoading(true);
            const response = await CoachAPI.findAllClubPlayer(selectedClub.clubId);
            setPlayers(response.Data);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }
    const findAllTeamPlayers = async () => {
        try {
            setIsLoading(true);
            const response = await CoachAPI.findAllTeamPlayer(state?.teamId);
            setTeamPlayers(response.Data);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }
    const addPlayerToTeam = async () => {
        try {
            setIsLoading(true);
            await CoachAPI.postAddPLayerToTeam({
                teamId: state?.teamId,
                playerData: selectedPlayer.map((player) => ({
                    playerId: player?.playerId,
                    isChild: player?.isChild
                }))
            })
            setOpenDialog(false);
            setSelectedPlayer([]);
            setIsUpdate(true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }
    const removePlayerToTeam = async (playerId, isChild) => {
        try {
            setIsLoading(true);
            await CoachAPI.deletePlayerFromTeam({
                teamId: state.teamId,
                playerId: playerId,
                isChild: isChild,
                childrenId: playerId
            })
            setIsUpdate(true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        findAllPlayers();
    }, []);
    useEffect(() => {
        findAllTeamPlayers();
        isUpdate && setIsUpdate(false);
    }, [isUpdate])



    const createNewList = () => {
        const playerIds = teamPlayers.map((item) => item.playerId);

        const onlyInList = players.filter(item => !playerIds.includes(item.playerId));

        return onlyInList.map((player) => ({
            playerId: player?.playerId,
            label: player?.firstName + " " + player?.lastName,
            email:player?.email,
            profileImg: player?.profileLogo,
            isChild: player?.child
        }))
    }
    const playerList = createNewList();
    const calculateAge = (dobVal) => {
        const today = new Date();
        const dob = new Date(dobVal);
        return today.getFullYear() - dob.getFullYear();
    }

    return (
        <div className='sm_team_player_list_con'>
            {isLoading && <Loader />}
            <div className='sm_team_player_list_add_player'>
                <h1>Players</h1>
                <button type='button' onClick={() => setOpenDialog(true)}>Add Member</button>
            </div>
            <table className='sm_team_player_list_table'>
                <thead>
                    <tr>
                        <th align='left'></th>
                        <th align='left'>First Name</th>
                        <th align='left'>Last Name</th>
                        <th align='left'>Age</th>
                        <th align='left'>Date of Birth</th>
                        <th align='left'>Email</th>
                        <th align='center'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {teamPlayers.length == 0 ?
                        <tr className='sm_no_player_found_in_team'>
                            <td colSpan={7}>No Player Found</td>
                        </tr>
                        :
                        <>
                            {teamPlayers?.map((player, index) =>
                                <tr key={index}>
                                    <td align='center'><Avatar sx={{ background: 'white' }} src={defaultProfileImg} /></td>
                                    <td align='left'>{player?.firstName}</td>
                                    <td>{player?.lastName}</td>
                                    <td align='left'>{calculateAge(player?.dob)}</td>
                                    <td>{player?.dob}</td>
                                    <td>{player?.email ? player.email : 'NA'}</td>
                                    <td align='center'><TiUserDeleteOutline className='sm_remove_player_from_team_icon' onClick={() => removePlayerToTeam(player.playerId, player.child)} /></td>
                                </tr>)}
                        </>}
                </tbody>
            </table>


            <CustomDialog
                title="Add Player"
                isOpen={openDialog}
                onClose={() => setOpenDialog(false)}
                onCancel={() => setOpenDialog(false)}
                onSubmit={addPlayerToTeam}
                submitBtnName='Add'
            >
                <div className='sm_team_player_add_player_input'>
                    <Autocomplete
                        multiple
                        options={playerList || []}
                        value={selectedPlayer}
                        isOptionEqualToValue={(option, value) => option.playerId === value.playerId}
                        onChange={(event, val) => setSelectedPlayer(val)}
                        fullWidth
                        sx={{ width: '100%', marginTop: 2 }}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                                const { key, ...chipProps } = getTagProps({ index });
                                return (
                                    <Chip
                                        key={key}
                                        label={option.label}
                                        {...chipProps}
                                        sx={{ background: 'var(--hoverColorBold)', fontWeight: 600 }}
                                    />
                                )
                            }
                            )
                        }
                        renderInput={(params) => <TextField className='signup-text-input' {...params} label="Players" />}
                        renderOption={(props, option, { selected }) => {
                            const { key, ...rest } = props;
                            return (
                                <li {...rest} key={key} className='sm_add_player_list_options' style={{
                                    backgroundColor: selected ? 'var(--hoverColorLight)' : 'white',
                                    fontWeight: selected ? 'bold' : 'normal',
                                    display:'flex',gap:'15px'
                                }}>
                                    <Avatar src={ `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${option.profileImg}`} /> 
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <h4>{option.label}</h4>
                                        <p>{option?.email}</p>
                                    </div>
                                </li>
                            )
                        }}
                    />
                </div>

            </CustomDialog>
        </div>
    )
}

export default TeamPlayerList